[
    "identity/users/edituser",
    "identity/roles/editrole",
    "identity/groups/editgroup",
    "identity/groups/creategroup",
    "identity/users/createuser",
    "identity/roles/createrole",
    "identity/companyaccessrestrictions/editcompanyaccessrestriction",
    "identity/companyaccessrestrictions/createcompanyaccessrestriction",
    "corepatterns/cultures/createculture",
    "corepatterns/cultures/editculture",
    "corepatterns/companies/editcompany",
    "corepatterns/companies/createcompany",
    "corepatterns/currencies/editcurrency",
    "corepatterns/currencies/createcurrency",
    "corepatterns/countries/editcountry",
    "corepatterns/countries/createcountry",
    "corepatterns/regions/editregion",
    "corepatterns/regions/createregion",
    "corepatterns/postalzones/editpostalzone",
    "corepatterns/postalzones/createpostalzone",
    "corepatterns/units/editunit",
    "corepatterns/units/createunit",
    "corepatterns/unitdimensions/editunitdimension",
    "corepatterns/unitdimensions/createunitdimension",
    "corepatterns/addresses/editaddress",
    "corepatterns/addresses/createaddress",
    "corepatterns/sequences/createstandardsequence",
    "corepatterns/sequences/editstandardsequence",
    "corepatterns/contacts/editcontact",
    "corepatterns/contacts/createcontact",
    "corepatterns/contacttypes/editcontacttype",
    "corepatterns/contacttypes/createcontacttype",
    "corepatterns/contactgroups/editcontactgroup",
    "corepatterns/contactgroups/createcontactgroup",
    "corepatterns/assignments/editassignment",
    "corepatterns/assignments/createassignment",
    "corepatterns/assignments/createsidebarassignment",
    "corepatterns/assignments/editsidebarassignment",
    "corepatterns/schemaentities/editcustomentity",
    "corepatterns/schemaentities/createcustomentity",
    "operations/notifications/createnotification",
    "operations/notifications/editnotification",
    "operations/emailtemplates/createemailtemplate",
    "operations/emailtemplates/editemailtemplate",
    "businesscore/series/createserie",
    "businesscore/parties/createpartybase",
    "businesscore/series/editserie",
    "businesscore/parties/editpartybase",
    "businesscore/items/createitem",
    "businesscore/items/edititem",
    "businesscore/exchangeratesdocuments/createexchangeratesdocument",
    "businesscore/exchangeratesdocuments/editexchangeratesdocument",
    "businesscore/assortments/editassortment",
    "businesscore/assortments/createassortment",
    "businesscore/brands/editbrand",
    "businesscore/brands/createbrand",
    "businesscore/brandmodels/editbrandmodel",
    "businesscore/brandmodels/createbrandmodel",
    "taxescore/fiscaldocumenttypes/editfiscaldocumenttype",
    "taxescore/taxtypecodes/edittaxtypecode",
    "taxescore/taxtypecodes/createtaxtypecode",
    "taxescore/taxregionalareas/edittaxregionalarea",
    "taxescore/taxclasses/edittaxclass",
    "taxescore/taxsubclasses/edittaxsubclass",
    "taxescore/partytaxschemas/editpartytaxschema",
    "taxescore/partytaxschemas/createpartytaxschema",
    "taxescore/itemtaxschemas/edititemtaxschema",
    "taxescore/itemtaxschemas/createitemtaxschema",
    "taxescore/fiscalclassifications/editfiscalclassification",
    "taxescore/exemptionreasoncodes/editexemptionreasoncode",
    "taxescore/economicactivityclassifications/editeconomicactivityclassification",
    "taxescore/economicactivityclassifications/createeconomicactivityclassification",
    "taxescore/taxessetups/edittaxessetup",
    "taxescore/withholdingtaxcodes/editwithholdingtaxcode",
    "taxescore/withholdingtaxcodes/createwithholdingtaxcode",
    "taxescore/partywithholdingtaxschemas/editpartywithholdingtaxschema",
    "taxescore/partywithholdingtaxschemas/createpartywithholdingtaxschema",
    "taxescore/itemwithholdingtaxschemas/edititemwithholdingtaxschema",
    "taxescore/itemwithholdingtaxschemas/createitemwithholdingtaxschema",
    "taxescore/withholdingtaxtypes/editwithholdingtaxtype",
    "taxescore/withholdingtaxtypes/createwithholdingtaxtype",
    "taxescore/paymentmethodfiscalclassifications/editpaymentmethodfiscalclassification",
    "taxescore/fiscalwitholdingtaxtypes/editfiscalwitholdingtaxtype",
    "taxescore/authoritycommunicationrequests/editauthoritycommunicationrequest",
    "taxescore/taxsubclasses/createtaxsubclass",
    "taxescore/taxessetupcvs/edittaxessetupcv",
    "taxescore/taxregionalareas/createtaxregionalarea",
    "taxescore/authoritycommunicationrequestcvs/editauthoritycommunicationrequestcv",
    "taxescore/fiscalissuereasons/editfiscalissuereason",
    "taxescore/seriescommunications/communicateseries",
    "taxescore/processcommunicationrequests/processrequest",
    "taxescore/processcommunicationrequestcvs/processrequestcv",
    "financialcore/paymentmethods/editpaymentmethod",
    "financialcore/paymentmethods/createpaymentmethod",
    "financialcore/paymentterms/editpaymentterm",
    "financialcore/paymentterms/createpaymentterm",
    "financialcore/checks/editcheck",
    "financialcore/checks/createcheck",
    "financialcore/paymenttypes/editpaymenttype",
    "financialcore/paymenttypes/createpaymenttype",
    "financialcore/receipttypes/editreceipttype",
    "financialcore/receipttypes/createreceipttype",
    "financialcore/financialsetups/editfinancialsetup",
    "financialcore/cashflowitems/editcashflowitem",
    "financialcore/cashflowitems/createcashflowitem",
    "financialcore/voidreasons/editvoidreason",
    "financialcore/voidreasons/createvoidreason",
    "financialcore/outgoingchecklots/editoutgoingchecklot",
    "financialcore/outgoingchecklots/createoutgoingchecklot",
    "financialcore/financialaccounts/editfinancialaccount",
    "financialcore/financialaccounts/createfinancialaccount",
    "financialcore/purposes/editpurpose",
    "financialcore/purposes/createpurpose",
    "financialcore/dunningmethods/editdunningmethod",
    "financialcore/dunningmethods/createdunningmethod",
    "financialcore/paymentcategorypurposes/editpaymentcategorypurpose",
    "financialcore/paymentcategorypurposes/createpaymentcategorypurpose",
    "financialcore/bankaccounttypes/editbankaccounttype",
    "financialcore/bankaccounttypes/createbankaccounttype",
    "financialcore/accountpostings/editaccountposting",
    "financialcore/accountpostings/createaccountposting",
    "financialcore/accounts/editaccount",
    "financialcore/accounts/createaccount",
    "financialcore/accounttypes/editaccounttype",
    "financialcore/accountingsetups/editaccountingsetup",
    "financialcore/financialaccountentries/editfinancialaccountentry",
    "financialcore/financialaccountentries/createfinancialaccountentry",
    "financialcore/financialaccounttransfers/editfinancialaccounttransfer",
    "financialcore/financialaccounttransfers/createfinancialaccounttransfer",
    "financialcore/financialinstitutions/editfinancialinstitution",
    "financialcore/financialinstitutions/createfinancialinstitution",
    "financialcore/financialparties/editfinancialparty",
    "financialcore/financialparties/createfinancialparty",
    "financialcore/partybankaccounts/editpartybankaccount",
    "financialcore/partybankaccounts/createpartybankaccount",
    "materialscore/itemsubtypes/edititemsubtype",
    "materialscore/itemsubtypes/createitemsubtype",
    "materialscore/materialssetups/editmaterialssetup",
    "materialscore/inventorypostings/editinventoryposting",
    "materialscore/inventorypostings/createinventoryposting",
    "materialscore/warehouses/editwarehousesview",
    "materialscore/warehouses/createwarehousesview",
    "materialscore/materialsitems/editmaterialsitemview",
    "materialscore/materialsitems/creatematerialsitemview",
    "materialscore/classifyitems/classifyitems",
    "salescore/salessetups/editsalessetup",
    "salescore/pricelists/editpricelist",
    "salescore/customergroups/editcustomergroup",
    "salescore/customergroups/createcustomergroup",
    "salescore/saleschannels/editsaleschannel",
    "salescore/saleschannels/createsaleschannel",
    "salescore/ordertypes/editordertypemain",
    "salescore/ordertypes/createordertypemain",
    "salescore/quotationtypes/editquotationtypemain",
    "salescore/quotationtypes/createquotationtypemain",
    "salescore/invoicetypes/editinvoicetypemain",
    "salescore/invoicetypes/createinvoicetypemain",
    "salescore/memotypes/editmemotypemain",
    "salescore/memotypes/creatememotypemain",
    "salescore/stores/editstore",
    "salescore/stores/createstore",
    "salescore/posdevices/editposdevice",
    "salescore/salespersons/editsalesperson",
    "salescore/salespersons/createsalesperson",
    "salescore/salesitems/editsalesitem",
    "salescore/salesitems/createsalesitem",
    "salescore/customerparties/editcustomerparty",
    "salescore/customerparties/createcustomerparty",
    "salescore/changesalesitemsprices/changesalesitemsprices",
    "salescore/associatesalesitemstosaleschannels/associatesalesitemstosaleschannels",
    "salescore/changesalesitems/changesalesitems",
    "logisticscore/deliveryterms/editdeliveryterm",
    "logisticscore/deliveryterms/createdeliveryterm",
    "logisticscore/memoreasons/editmemoreason",
    "logisticscore/memoreasons/creatememoreason",
    "logisticscore/goodsreceiptnotetypes/editgoodsreceiptnotetype",
    "logisticscore/goodsreceiptnotetypes/creategoodsreceiptnotetype",
    "logisticscore/deliverytypes/editdeliverytype",
    "logisticscore/deliverytypes/createdeliverytype",
    "logisticscore/shippingmethods/editshippingmethod",
    "logisticscore/shippingmethods/createshippingmethod",
    "logisticscore/logisticssetups/editstandardlogisticssetup",
    "sales/orders/editorder",
    "sales/orders/createorder",
    "sales/quotations/editstandardquotation",
    "sales/quotations/createstandardquotation",
    "purchasescore/suppliergroups/editsuppliergroup",
    "purchasescore/suppliergroups/createsuppliergroup",
    "purchasescore/invoicetypes/editinvoicetype",
    "purchasescore/invoicetypes/createinvoicetype",
    "purchasescore/memotypes/editmemotype",
    "purchasescore/memotypes/creatememotype",
    "purchasescore/ordertypes/editordertype",
    "purchasescore/ordertypes/createordertype",
    "purchasescore/purchasessetups/editpurchasessetup",
    "purchasescore/purchasesitems/editpurchasesitem",
    "purchasescore/purchasesitems/createpurchasesitem",
    "purchasescore/supplierparties/editsupplierpartymain",
    "purchasescore/supplierparties/createsupplierpartymain",
    "purchases/orders/editstandardorder",
    "purchases/orders/createstandardorder",
    "shipping/deliveries/editstandarddelivery",
    "shipping/deliveries/createstandarddelivery",
    "shipping/shippingrequests/editmainres",
    "shipping/shippingrequests/createmainres",
    "shipping/processorders/shippingorders",
    "billing/invoices/editstandardinvoice",
    "billing/invoices/createinvoice",
    "billing/memos/editstandardmemos",
    "billing/memos/createstandardmemos",
    "billing/billingrequests/editstandardbillingrequests",
    "billing/recurringinvoicetemplates/editresourcerecurringtemplate",
    "billing/recurringinvoicetemplates/createresourcerecurringtemplate",
    "billing/recurringinvoiceschedules/editresourcerecurringinvoiceschedule",
    "billing/processorders/processorders",
    "billing/processreturnorders/processreturnorders",
    "goodsreceipt/goodsreceiptnotes/editstandardgoodsreceiptnote",
    "goodsreceipt/goodsreceiptnotes/createstandardgoodsreceiptnote",
    "goodsreceipt/goodsreceiptnotifications/editstandardgoodsreceiptnotification",
    "goodsreceipt/goodsreceiptnotifications/createstandardgoodsreceiptnotification",
    "goodsreceipt/processorders/processorders",
    "materialsmanagement/adjustmentreasons/editadjustmentreason",
    "materialsmanagement/adjustmentreasons/createadjustmentreason",
    "materialsmanagement/itemadjustments/edititemadjustmentview",
    "materialsmanagement/itemadjustments/createitemadjustmentview",
    "materialsmanagement/stocktransferorders/editstandardstocktransferorder",
    "materialsmanagement/stocktransferorders/createstandardstocktransferorder",
    "bankaccounting/depositslips/editdepositslipmain",
    "bankaccounting/depositslips/createdepositslipmain",
    "bankaccounting/financialaccountpostings/editfinancialaccountpostingmain",
    "bankaccounting/financialaccountpostings/createfinancialaccountpostingmain",
    "bankaccounting/outgoingchecks/editoutgoingcheck",
    "bankaccounting/outgoingchecks/createoutgoingcheck",
    "bankaccounting/checkvoids/editcheckvoid",
    "bankaccounting/checkvoids/createcheckvoid",
    "bankaccounting/directdebitfiles/editdirectdebitfile",
    "bankaccounting/directdebitfiles/createdirectdebit",
    "bankaccounting/reconciliations/editreconciliation",
    "bankaccounting/reconciliations/createreconciliation",
    "bankaccounting/processdirectdebitfilerequests/createdirectdebitfile",
    "bankaccounting/processdirectdebitstaterequests/changestatusdirectdebitfileline",
    "bankaccounting/processreconciliationrequests/processreconciliationrequests",
    "cashmanagement/incomingchecks/editincomingcheck",
    "cashmanagement/incomingchecks/createincomingcheck",
    "cashmanagement/incomingcashjournals/editincomingcashjournal",
    "cashmanagement/incomingcashjournals/createincomingcashjournal",
    "cashmanagement/outgoingcashjournals/editoutgoingcashjournal",
    "cashmanagement/outgoingcashjournals/createoutgoingcashjournal",
    "taxes/legaldeclarations/editlegaldeclaration",
    "taxes/legaldeclarations/createlegaldeclaration",
    "taxes/inventorydeclarations/editinventorydeclaration",
    "taxes/inventorydeclarations/createinventorydeclaration",
    "taxes/manualcommunicationrequests/editmanualcommunicationrequest",
    "taxes/manualcommunicationrequests/createmanualcommunicationrequest",
    "taxes/generatesafts/editgeneratesaft",
    "taxes/generatesafts/creategeneratesaft",
    "taxes/legaldeclarationcvs/editlegaldeclarationcv",
    "taxes/legaldeclarationcvs/createlegaldeclarationcv",
    "invoicereceipt/invoices/editstandardinvoice",
    "invoicereceipt/invoices/createstandardinvoice",
    "invoicereceipt/memos/editstandardmemo",
    "invoicereceipt/memos/createstandardmemo",
    "invoicereceipt/invoicereceiptnotifications/editreceiptnotification",
    "invoicereceipt/expenses/editstandardexpense",
    "invoicereceipt/expenses/createstandardexpense",
    "invoicereceipt/processorders/processorders",
    "invoicereceipt/processreturnorders/processreturnorders",
    "accountspayable/payments/editstandardpayment",
    "accountspayable/payments/createstandardpayment",
    "accountspayable/eftorders/editeftordermain",
    "accountspayable/eftorders/createeftordermain",
    "accountspayable/processopenitems/createpayment",
    "accountsreceivable/receipts/editreceiptsview",
    "accountsreceivable/receipts/createreceiptsview",
    "accountsreceivable/dunnings/editdunningview",
    "accountsreceivable/dunnings/createdunningview",
    "accountsreceivable/processopenitems/createreceipt",
    "reporting/templateentitygroups/edittemplateentitygroup"
]
